/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import './breadcrumbs.scss';
import { Link } from 'react-router-dom';
import useReactRouterBreadcrumbs from 'use-react-router-breadcrumbs';
import clsx from 'clsx';
import Icon, { IconColors, IconSizes, IconTypes } from '../icon';

const Breadcrumbs = ({ routes }) => {
  const breadcrumbs = useReactRouterBreadcrumbs(routes);

  const getItems = () => breadcrumbs.map(({ match, breadcrumb }, index) => {
    const isLast = index === breadcrumbs.length - 1;
    return (
      <span key={match.pathname + isLast} className={clsx('breadcrumb-item', { 'breadcrumb-active': isLast })}>
        <Link to={match.pathname}>{breadcrumb}</Link>
        {isLast ? null : (
          <Icon
            type={IconTypes.CHEVRON_RIGHT}
            size={IconSizes.SMALL}
            color={IconColors.LIGHT_GREY}
          />
        ) }
      </span>
    );
  });

  return (
    <div className="breadcrumbs-cont">
      {getItems()}
    </div>
  );
};

Breadcrumbs.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.any),
};

Breadcrumbs.defaultProps = {
  routes: [],
};

export {
  Breadcrumbs as default,
};
